import { useBuybackEnabled } from '@backmarket/nuxt-layer-buyback/app/composables/useBuybackEnabled/useBuybackEnabled'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

export function useSwapEnabled() {
  const { isBuybackEnabled } = useBuybackEnabled()
  const experiments = useExperiments()

  const isSwapEnabled =
    isBuybackEnabled &&
    experiments['experiment.swapItaly'] !== 'without' &&
    experiments['experiment.tradeInJP'] !== 'disabled'

  return { isSwapEnabled }
}
